export enum BUTTON_TYPES {
	PRIMARY = 'PRIMARY',
	SECONDARY = 'SECONDARY',
	TERTIARY = 'TERTIARY',
	POSITIVE = 'POSITIVE',
	NEGATIVE = 'NEGATIVE',
	ACTION = 'ACTION'
}

export enum BUTTON_SIZE {
	LARGE = 'LARGE',
	SMALL = 'SMALL'
}

export enum BUTTON_ICON_POS {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	TOP = 'TOP',
	BOTTOM = 'BOTTOM'
}

export enum INPUT_TYPE {
	TEXT = 'TEXT',
	NUMBER = 'NUMBER',
	EMAIL = 'EMAIL',
	PHONE = 'PHONE',
	PASSWORD = 'PASSWORD'
}

export enum INPUT_SIZE {
	SMALL = 'SMALL',
	REGULAR = 'REGULAR'
}

export enum SPACER_DIRECTION {
	HORIZONTAL = 'HORIZONTAL',
	VERTICAL = 'VERTICAL'
}

export enum TAB_BAR_DIRECTION {
	HORIZONTAL = 'HORIZONTAL',
	VERTICAL = 'VERTICAL'
}

export enum CHIP_TYPE {
	INFO = 'INFO',
	WARN = 'WARN',
	ERROR = 'ERROR',
	SUCCESS = 'SUCCESS',
	NEUTRAL = 'NEUTRAL',
	BRAND = 'BRAND',
}

export enum CHIP_SIZE {
	LARGE = 'LARGE',
	MEDIUM = 'MEDIUM',
	SMALL = 'SMALL',
}

export enum BUTTON_ACTION_TYPE {
	BUTTON = 'button',
	SUBMIT = 'submit',
	RESET = 'reset'
}

export enum INPUT_ICON_POS {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT'
}

export enum TEMP_NAMES {
	AMBIENT = 'Ambient',
	CHILLED = 'Chilled',
	FROZEN = 'Frozen'
}

export enum TEMPERATURE {
	AMBIENT = 'AMBIENT',
	CHILLED = 'CHILLED',
	FROZEN = 'FROZEN'
}

export const getTemperatureLabel = (temperature: TEMPERATURE): string => {
	switch (temperature) {
	case TEMPERATURE.AMBIENT:
		return TEMP_NAMES.AMBIENT;
	case TEMPERATURE.CHILLED:
		return TEMP_NAMES.CHILLED;
	case TEMPERATURE.FROZEN:
		return TEMP_NAMES.FROZEN;
	default:
		return temperature
	}
}

export const temperatureLabelMap: Record<TEMPERATURE, TEMP_NAMES> = {
	[TEMPERATURE.AMBIENT]: TEMP_NAMES.AMBIENT,
	[TEMPERATURE.CHILLED]: TEMP_NAMES.CHILLED,
	[TEMPERATURE.FROZEN]: TEMP_NAMES.FROZEN,
};

export enum SELECT_ICON_POS {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT'
}

export enum TEXT_WEIGHT {
	REGULAR = 'regular',
	LIGHT = 'light',
	SEMI_BOLD = 'semiBold',
	BOLD = 'bold'
}

export enum TOOLTIP_POSITION {
	LEFT = 'left',
	RIGHT = 'right',
	TOP = 'top',
	BOTTOM = 'bottom'
}

export enum DG_OPTIONS {
	LOAD_CONTAINS_BULK_DANGEROUS_GOODS = 'LOAD_CONTAINS_BULK_DANGEROUS_GOODS',
	LOAD_CONTAINS_FULLY_REGULATED_DANGEROUS_GOODS = 'LOAD_CONTAINS_FULLY_REGULATED_DANGEROUS_GOODS',
	LOAD_CONTAINS_LIMITED_QUANTITIES = 'LOAD_CONTAINS_LIMITED_QUANTITIES'
}

export const getDangerousGoodOptionLabel = (option: string): string => {
	switch (option) {
	case DG_OPTIONS.LOAD_CONTAINS_BULK_DANGEROUS_GOODS:
		return 'Load contains bulk dangerous goods';
	case DG_OPTIONS.LOAD_CONTAINS_FULLY_REGULATED_DANGEROUS_GOODS:
		return 'Load contains fully regulated dangerous goods';
	case DG_OPTIONS.LOAD_CONTAINS_LIMITED_QUANTITIES:
		return 'Load contains limited quantities';
	default:
		throw new Error('Invalid Dangerous Good Option');
	}
}

export enum LOAD_SEC_REQ {
	TENSION_BELTS = 'TENSION_BELTS',
	EDGE_PROTECTION_SHIP_THIS_FREQUENTLY = 'EDGE_PROTECTION_SHIP_THIS_FREQUENTLY',
	DRIVER_ASSISTANCE_AT_STOP = 'DRIVER_ASSISTANCE_AT_STOP',
	ANTI_SLIP_MAT = 'ANTI_SLIP_MAT',
	MULTILOCK = 'MULTILOCK',
	IS_SIDEBOARDS_FIVE_PER_FIELD = 'IS_SIDEBOARDS_FIVE_PER_FIELD',
	CHAINS = 'CHAINS',
	STOP_BARS = 'STOP_BARS',
	CARGO_NET = 'CARGO_NET',
	COIL_SUPPORTS = 'COIL_SUPPORTS',
	TIR_CABLE = 'TIR_CABLE',
	ANGLES_STRAPS_PLY_FOR_ALL_PALLETS = 'ANGLES_STRAPS_PLY_FOR_ALL_PALLETS',
	CORFLUTE = 'CORFLUTE',
	GATES = 'GATES',
	LOADING_BARS = 'LOADING_BARS'
}

export const getLoadSecReqKey = (requirement: string, forEOS = false): string => {
	switch (requirement) {
	case LOAD_SEC_REQ.TENSION_BELTS:
		return forEOS ? 'tension_belts' : 'tension_belt';
	case LOAD_SEC_REQ.EDGE_PROTECTION_SHIP_THIS_FREQUENTLY:
		return 'edge_protect';
	case LOAD_SEC_REQ.DRIVER_ASSISTANCE_AT_STOP:
		return 'driver_assist_stop';
	case LOAD_SEC_REQ.ANTI_SLIP_MAT:
		return 'anti_slip_mat';
	case LOAD_SEC_REQ.MULTILOCK:
		return 'multilock';
	case LOAD_SEC_REQ.IS_SIDEBOARDS_FIVE_PER_FIELD:
		return 'sideboards';
	case LOAD_SEC_REQ.CHAINS:
		return 'chains';
	case LOAD_SEC_REQ.STOP_BARS:
		return 'stopbars';
	case LOAD_SEC_REQ.CARGO_NET:
		return 'cargo_net';
	case LOAD_SEC_REQ.COIL_SUPPORTS:
		return 'coil';
	case LOAD_SEC_REQ.TIR_CABLE:
		return 'tir_cable';
	case LOAD_SEC_REQ.ANGLES_STRAPS_PLY_FOR_ALL_PALLETS:
		return forEOS ? 'angle_straps_ply_for_all_pallets' : 'asp_pallets';
	case LOAD_SEC_REQ.CORFLUTE:
		return 'corflute';
	case LOAD_SEC_REQ.GATES:
		return 'gates';
	case LOAD_SEC_REQ.LOADING_BARS:
		return 'loading_bars';
	default:
		return '';
	}
}

export const getLoadSecReqENUM = (requirment: string): string => {
	switch (requirment) {
	case 'tension_belt':
		return LOAD_SEC_REQ.TENSION_BELTS;
	case 'edge_protect':
		return LOAD_SEC_REQ.EDGE_PROTECTION_SHIP_THIS_FREQUENTLY;
	case 'driver_assist_stop':
		return LOAD_SEC_REQ.DRIVER_ASSISTANCE_AT_STOP;
	case 'anti_slip_mat':
		return LOAD_SEC_REQ.ANTI_SLIP_MAT;
	case 'multilock':
		return LOAD_SEC_REQ.MULTILOCK;
	case 'sideboards':
		return LOAD_SEC_REQ.IS_SIDEBOARDS_FIVE_PER_FIELD;
	case 'chains':
		return LOAD_SEC_REQ.CHAINS;
	case 'stopbars':
		return LOAD_SEC_REQ.STOP_BARS;
	case 'cargo_net':
		return LOAD_SEC_REQ.CARGO_NET;
	case 'coil':
		return LOAD_SEC_REQ.COIL_SUPPORTS;
	case 'tir_cable':
		return LOAD_SEC_REQ.TIR_CABLE;
	case 'asp_pallets':
		return LOAD_SEC_REQ.ANGLES_STRAPS_PLY_FOR_ALL_PALLETS;
	case 'corflute':
		return LOAD_SEC_REQ.CORFLUTE;
	case 'gates':
		return LOAD_SEC_REQ.GATES;
	case 'loading_bars':
		return LOAD_SEC_REQ.LOADING_BARS;
	default:
		return '';
	}
}

export const getLoadingSecurityRequirementLabel = (requirement: LOAD_SEC_REQ | string): string => {
	switch (requirement) {
	case LOAD_SEC_REQ.TENSION_BELTS:
		return 'Tension belts';
	case LOAD_SEC_REQ.EDGE_PROTECTION_SHIP_THIS_FREQUENTLY:
		return 'Edge protection ship this frequently';
	case LOAD_SEC_REQ.DRIVER_ASSISTANCE_AT_STOP:
		return 'Driver assistance at stop';
	case LOAD_SEC_REQ.ANTI_SLIP_MAT:
		return 'Anti slip mat';
	case LOAD_SEC_REQ.MULTILOCK:
		return 'Multilock';
	case LOAD_SEC_REQ.IS_SIDEBOARDS_FIVE_PER_FIELD:
		return 'Is Sideboards (5) Per field';
	case LOAD_SEC_REQ.CHAINS:
		return 'Chains';
	case LOAD_SEC_REQ.STOP_BARS:
		return 'Stop bars';
	case LOAD_SEC_REQ.CARGO_NET:
		return 'Cargo net';
	case LOAD_SEC_REQ.COIL_SUPPORTS:
		return 'Coil supports';
	case LOAD_SEC_REQ.TIR_CABLE:
		return 'TIR cable';
	case LOAD_SEC_REQ.ANGLES_STRAPS_PLY_FOR_ALL_PALLETS:
		return 'Angles, Straps, & Ply for all pallets';
	case LOAD_SEC_REQ.CORFLUTE:
		return 'Corflute';
	case LOAD_SEC_REQ.GATES:
		return 'Gates';
	case LOAD_SEC_REQ.LOADING_BARS:
		return 'Loading Bars';
	default:
		return 'Unknown'
	}
}

export enum CARGO_TYPE {
	PALLETS = 'PALLETS',
	FTL = 'FTL',
	// Frontend-only: the Full Load "Container" tile. Converted to FTL before submit (buildBookShipmentSchema).
	FCL = 'FCL',
	LOOSE = 'LOOSE',
	ITEM = 'ITEM',
	/* To avoid breaking manifest and invoicing
	   Will be updated in the future */
	PARCELS = 'CARTONS',

	// Cargo item type for the Other flow, mirroring the shared PHP CargoType enum
	BUNDLE = 'BUNDLE',
	SKID = 'SKID',

	// Note: VOLUME and WEIGHT are deprecated
	VOLUME = 'VOLUME',
	WEIGHT = 'WEIGHT',
	OTHER = 'OTHER',
}

export const CARGO_ITEM_OPTIONS = {
	PALLETS: CARGO_TYPE.PALLETS,
	BUNDLE: CARGO_TYPE.BUNDLE,
	SKID: CARGO_TYPE.SKID,
	OTHER: CARGO_TYPE.OTHER,
} as const;

/* The cargo types an Item rate card can price, mirroring CargoType::isItem() in the shared enum
   package. Pallets price off their own rate card, so they aren't one. */
export const ITEM_DEFINITION_CARGO_TYPES = [CARGO_TYPE.BUNDLE, CARGO_TYPE.SKID, CARGO_TYPE.OTHER];

// Standard Australian pallet footprint; a Pallets row in the row editor starts at it.
export const STANDARD_PALLET_DIMENSION_CM = 117;

export enum MACHSHIP_ITEM_TYPE {
	CARTONS = 'CARTONS',
	SATCHELS = 'SATCHELS'
}

export enum CARGO_TYPE_LABEL {
	PALLETS = 'Less Than',
	FULL_TRUCK_LOAD = 'Full Load',
	VOLUMETRIC = 'Weight',
	LOADING_METRES = 'Loading Metres',
	LOOSE = 'Loose',
	OTHER = 'Other',
	PARCELS = 'Parcels',
	NOT_DEFINED = 'Not Defined',
	ITEM = 'Item',
	SATCHELS = 'Satchels',
	CARTONS = 'Cartons'
}

export enum RATE_CARD_TYPE_PRICING {
	PALLETS = 'PALLETS',
	WEIGHT = 'WEIGHT',
	FULL_LOAD = 'FULL_LOAD',
	CPK = 'CPK',
	ITEM = 'ITEM',
	/* The row editor's pricing method: always for shippers, and the default for admins. The backend
	   tries per-item rate cards, then per space (pallet-only bookings), then CPK (BED-136). */
	PER_ITEM = 'PER_ITEM',
	CARTONS = 'CARTONS'
}

export enum CAPACITY_TYPE {
	FTL = 'FTL',
	PARTIAL = 'PARTIAL',
	VOLUMETRIC = 'VOLUMETRIC'
}

export const getCapacityTypeLabel = (capacityType: CAPACITY_TYPE): string => {
	switch (capacityType) {
	case CAPACITY_TYPE.VOLUMETRIC:
		return 'Other';
	case CAPACITY_TYPE.PARTIAL:
		return 'Less Than';
	case CAPACITY_TYPE.FTL:
	default:
		return 'Full Load';
	}
}

export const getCapacityCargoTypeLabel = (cargoType: CARGO_TYPE): string => {
	switch (cargoType) {
	case CARGO_TYPE.PALLETS:
		return 'Pallets';
	case CARGO_TYPE.LOOSE:
		return 'Loose';
	case CARGO_TYPE.FCL:
		return 'Container';
	case CARGO_TYPE.OTHER:
		return 'Other';
	case CARGO_TYPE.ITEM:
		return 'Item';
	case CARGO_TYPE.PARCELS:
		return 'Parcels';
	case CARGO_TYPE.BUNDLE:
		return 'Bundle';
	case CARGO_TYPE.SKID:
		return 'Skid';
	default:
		return cargoType;
	}
}

export enum CARGO_PICKER_TYPE {
	CAPACITY_DETAILS = 'capacity_details',
	CARGO_DETAILS = 'cargo_details',
	PALLET_OPTIONS = 'pallet_options',
	TRUCK_OPTIONS = 'truck_options',
	LOADING_OPTIONS = 'loading_options',
}

export enum CARGO_OPTIONS {
	NOT_DEFINED = 0,
	PALLETS = 1,
	FULL_TRUCK_LOAD = 2,
	VOLUMETRIC = 3,
	LOADING_METRES = 4,
	ITEM = 7,
	PARCELS = 8
}

export enum TRUCK_OPTIONS {
	RIGID = 'Rigid',
	SINGLE = 'Single',
	A_DOUBLE = 'A-Double',
	B_DOUBLE = 'B-Double',
	B_TRIPLE = 'B-Triple',
	B_DOUBLE_HIGH_CUBE = 'B-Double High Cube',
	B_DOUBLE_SUPER_HIGH_CUBE = 'B-Double Super High Cube',
	FT20_CONTAINER = '20ft Container',
	FT40_CONTAINER = '40ft Container',
	FT20_Container_SERVER = 'Container (20FT Coastal)',
	FT40_Container_SERVER = 'Container (40FT Coastal)',
	SUPER_B_DOUBLE = 'Super B-Double',
	FT46_CONTAINER = 'Container (46FT Coastal)',
	FT48_CONTAINER = 'Container (48FT Coastal)',
}

export enum LOADING_OPTIONS {
	BACK = 'From back',
	SIDE = 'From side',
	TOP = 'From top',
	LIFTGATE = 'From liftgate'
}

export enum AVATAR_SIZE {
	LARGE = 'large',
	REGULAR = 'regular',
	SMALL = 'small',
	XSMALL = 'xsmall',
	XXSMALL = 'xxsmall',
	MICRO = 'micro'
}

export enum DATA_UPDATE_MODE {
	/** The server sorts, searches, filters and pages; the grid asks it for one page at a time. */
	SERVER = 'server',
	/** The grid sorts the rows it was handed. Search, filter and paging stay the consumer's. */
	SORT_LOCAL = 'local',
	/* The grid sorts, searches, filters and pages them itself, so it has to be handed every row
	   rather than a page of them. Read by DataGrid only — Table treats it as neither mode. */
	FULLY_LOCAL = 'fullyLocal'
}

export enum DATA_SORT_ORDER {
	DESC = 'desc',
	ASC = 'asc'
}

export enum TABLE_ROW_DENSITY {
	SUPER_COMPACT = 'superCompact',
	COMPACT = 'compactRow',
	REGULAR = 'regularRow',
	EXPANDED = 'expandedRow'
}

export enum TIMESLOT_OPTIONS {
	NOT_REQUIRED = 'NOT_REQUIRED',
	OFLOAD_MUST_BOOK = 'OFLOAD_MUST_BOOK',
	BOOKED = 'BOOKED'
}

export enum POD_STATUS_NUM {
	POD_REQUIRED = 1,
	POD_AWAITING_VERIFICATION = 2,
	POD_REJECTED = 3,
	POD_VERIFIED = 4,
	POD_AUTO_APPROVED = 12,
	POD_VERIFIED_PROCESSING = 13,
	POD_AUTO_REJECTED = 14,
	// manifest.admin_pod_status
	POD_CHASING = 5,
	POD_IN_DISPUTE = 6,
	POD_CHASED_AND_ABANDONED = 7,
	POD_NOT_AVAILABLE = 8,
	LOAD_NOT_DELIVERED = 9,
	POD_SHIPPER_CHASING = 10,
	POD_REJECTED_BY_SHIPPER = 11
}

export enum POD_STATUS {
	POD_VERIFIED = 'POD Approved',
	POD_AUTO_APPROVED = 'POD Auto Approved',
	POD_REQUIRED = 'Awaiting POD',
	AWAITING_VERIFICATION = 'Awaiting Verification',
	POD_AWAITING_VERIFICATION = 'POD Awaiting Verification',
	POD_REJECTED = 'POD Rejected',
	POD_AUTO_REJECTED = 'POD Auto Rejected',
	POD_CHASING = 'Ofload Chasing',
	POD_IN_DISPUTE = 'In Dispute',
	POD_CHASED_AND_ABANDONED = 'Chased And Abandoned',
	POD_NOT_AVAILABLE = 'Carrier Advising Not Available',
	LOAD_NOT_DELIVERED = 'Load Not Delivered',
	POD_SHIPPER_CHASING = 'Shipper Chasing',
	POD_REJECTED_BY_SHIPPER = 'Rejected By Shipper',
	POD_VERIFIED_PROCESSING = 'Verified POD & Processing',
	UNKNOWN = 'Unknown'
}

export const POD_STATUS_NUM_TO_STRING = (statusNum: number) => {
	switch (statusNum) {
	case 1:
		return POD_STATUS.POD_REQUIRED
	case 2:
		return POD_STATUS.POD_AWAITING_VERIFICATION
	case 3:
		return POD_STATUS.POD_REJECTED
	case 4:
		return POD_STATUS.POD_VERIFIED
	case 5:
		return POD_STATUS.POD_CHASING
	case 6:
		return POD_STATUS.POD_IN_DISPUTE
	case 7:
		return POD_STATUS.POD_CHASED_AND_ABANDONED
	case 8:
		return POD_STATUS.POD_NOT_AVAILABLE
	case 9:
		return POD_STATUS.LOAD_NOT_DELIVERED
	case 10:
		return POD_STATUS.POD_SHIPPER_CHASING
	case 11:
		return POD_STATUS.POD_REJECTED_BY_SHIPPER
	case 12:
		return POD_STATUS.POD_AUTO_APPROVED
	case 13:
		return POD_STATUS.POD_VERIFIED_PROCESSING
	case 14:
		return POD_STATUS.POD_AUTO_REJECTED
	default:
		return POD_STATUS.UNKNOWN;
	}
}

export const POD_STATUS_STRING_TO_NUM = (status: POD_STATUS) => {
	switch (status) {
	case POD_STATUS.POD_REQUIRED:
		return 1;
	case POD_STATUS.POD_AWAITING_VERIFICATION:
		return 2;
	case POD_STATUS.POD_REJECTED:
		return 3;
	case POD_STATUS.POD_VERIFIED:
		return 4;
	case POD_STATUS.POD_CHASING:
		return 5;
	case POD_STATUS.POD_IN_DISPUTE:
		return 6;
	case POD_STATUS.POD_CHASED_AND_ABANDONED:
		return 7;
	case POD_STATUS.POD_NOT_AVAILABLE:
		return 8;
	case POD_STATUS.LOAD_NOT_DELIVERED:
		return 9;
	case POD_STATUS.POD_SHIPPER_CHASING:
		return 10;
	case POD_STATUS.POD_REJECTED_BY_SHIPPER:
		return 11;
	case POD_STATUS.POD_AUTO_APPROVED:
		return 12;
	case POD_STATUS.POD_AUTO_REJECTED:
		return 14;
	default:
		return 0;
	}
}

export enum INVOICE_POD_STATUS {
	POD_VERIFIED = 'POD Approved',
	POD_AUTO_APPROVED = 'POD Auto Approved',
	POD_VERIFIED_PROCESSING = 'Verified POD & Processing',
	POD_REQUIRED = 'Awaiting POD',
	AWAITING_VERIFICATION = 'Awaiting Verification',
	POD_AWAITING_VERIFICATION = 'POD Awaiting Verification',
	POD_REJECTED = 'POD Rejected'
}

export enum INVOICE_STATUS {
	/* @deprecated */
	NO_INVOICE_PROVIDED = 'NO_INVOICE_PROVIDED',
	/* @deprecated */
	PENDING_OR_CHASING = 'PENDING_OR_CHASING',

	PAYMENT_DISPUTE = 'PAYMENT_DISPUTE',
	SHIPPER_PROMISED_TO_PAY = 'SHIPPER_PROMISED_TO_PAY',
	CARRIER_DO_NOT_PAY = 'CARRIER_DO_NOT_PAY',
	CARRIER_PAYMENT_DISPUTE = 'CARRIER_PAYMENT_DISPUTE'
}

export enum INVOICE_STATUS_LABEL {
	PAYMENT_DISPUTE = 'Shipper Payment Dispute',
	NO_INVOICE_PROVIDED = 'No Carrier Invoice Provided',
	PENDING_OR_CHASING = 'Carrier Invoice Pending/Chasing',
	SHIPPER_PROMISED_TO_PAY = 'Shipper Promised To Pay',
	SHIPPER_PAID = 'Shipper Paid',
	SHIPPER_INVOICE = 'Shipper Invoiced',
	SHIPPER_INVOICE_GENERATED = 'Shipper Invoice Generated',
	AWAITING_SHIPPER_INVOICE = 'Awaiting Shipper Invoice',
	OVERDUE_SHIPPER_PAYMENT = 'Overdue Shipper Payment',
	CARRIER_DO_NOT_PAY = 'Do Not Pay',
	CARRIER_PAYMENT_DISPUTE = 'Carrier Payment Dispute',
	CARRIER_PAID = 'Carrier Paid',
	CARRIER_PAID_BUTN = 'Carrier Paid Via Butn',
	CARRIER_PAID_RCTI = 'Carrier Paid Via RCTI',
	CARRIER_INVOICED = 'Carrier Invoiced',
	AWAITING_CARRIER_INVOICE = 'Awaiting Carrier Invoice',
	CARRIER_PAID_MANUAL_REC = 'Carrier Paid via Manual Rec',
}

export const CARGO_TYPE_ID = {
	Pallets: 1,
	FullTruckload: 2,
	Volumetric: 3,
	LoadingMeters: 4,
	NotDefined: 0,
	Loose: 5,
	Other: 6,
	CustomItem: 7,
	Parcels: 8,
	// 9 is Satchels (deprecated) in the shared BE enum - not assigned here, so skipped.
	Bundle: 10,
	Skid: 11
}

export const JOB_STATUS = {
	UNALLOCATED: 0,
	IN_MARKETPLACE: 1,
	PREMIUM_LIST: 2,
	ALLOCATED: 3,
	CANCEL: 4,
}

export const ALLOCATION_STATUS = {
	UNALLOCATED: 'UNALLOCATED',
	IN_MARKETPLACE: 'IN_MARKETPLACE',
	ALLOCATED: 'ALLOCATED',
	CANCELLED: 'CANCELLED',
} as const;

export type TAllocationStatus = typeof ALLOCATION_STATUS[keyof typeof ALLOCATION_STATUS];

export const QuoteFilterableStatus = [
	{ value: 'pending', label: 'Pending' },
	{ value: 'priced', label: 'Priced' },
	{ value: 'expired', label: 'Expired' },
	{ value: 'not_quoted', label: 'Not Quoted' }
]

export const TRANSPORT_SHIPMENT_FILTERABLE_STATUS = [
	'Allocated',
	'On The Road',
	'Delivered',
	'Awaiting POD Upload',
	'POD Awaiting Verification',
	'POD Rejected',
	'Shipper Invoice Generated',
	'Awaiting Carrier Invoice',
	'Shipper Invoiced',
	'Carrier Invoiced',
	'Overdue Shipper Payment',
	'Shipper Paid',
	'Carrier Paid',
	'Chasing POD',
	'In Dispute',
	'POD Chased And Abandoned',
	'No POD Available',
	'Shipper Payment Dispute',
	'Carrier Invoice Pending/Chasing',
	'No Carrier Invoice Provided',
];

export const INVOICE_FILTERABLE_STATUS = [
	{
		name: 'Shipper',
		expanded: true,
		options: [
			{
				label: 'Awaiting Shipper Invoice',
				value: 'shipper-awaiting-invoice'
			},
			{
				label: 'Shipper Invoice Generated',
				value: 'shipper-invoice-generated'
			},
			{
				label: 'Shipper Invoiced',
				value: 'shipper-invoiced'
			},
			{
				label: 'Shipper Paid',
				value: 'shipper-paid'
			},
			{
				label: 'Shipper Payment Dispute',
				value: 'shipper-payment-dispute',
			},
			{
				label: 'Shipper Promised To Pay',
				value: 'shipper-promised-to-pay',
			},
			{
				label: 'Overdue Shipper Payment',
				value: 'shipper-payment-overdue'
			},
		]
	},
	{
		name: 'Carrier',
		expanded: true,
		options: [
			{
				label: 'Awaiting Carrier Invoice',
				value: 'carrier-awaiting-invoice'
			},
			{
				label: 'Carrier Invoiced',
				value: 'carrier-invoiced'
			},
			{
				label: 'Carrier Invoice Pending/Chasing',
				value: 'carrier-pending-or-chasing',
			},
			{
				label: 'Carrier Paid Via Butn',
				value: 'carrier-paid-butn'
			},
			{
				label: 'Carrier Paid Via RCTI',
				value: 'carrier-paid-rcti'
			},
			{
				label: 'Carrier Payment Dispute',
				value: 'carrier-payment-dispute',
			},
			{
				label: 'No Carrier Invoice Provided',
				value: 'carrier-no-invoice-provided',
			},
			{
				label: 'Do Not Pay',
				value: 'carrier-do-not-pay',
			},
		]
	},
]

export const ShipmentFilterableStatus = ['Pending', 'Allocated', 'On The Road', 'Delivered', 'Awaiting', 'Paid'];

export const SHIPMENT_FILTERABLE_STATUS = [
	'Allocated',
	'On The Road',
	'Delivered',
];

export enum SHIPMENT_STATUS {
	PENDING = 10,
	ALLOCATED = 20,
	PICKUP = 30,
	DELIVERED = 40,
	POD_RECEIVED = 50,
	COMPLETE = 60,
	PAID = 65,
	COMPLETE_WITH_CARRIER_CLAIM = 70,
	COMPLETE_WITH_SHIPPER_CLAIM = 80,
	COMPLETE_WITH_CLAIM_RESOLVED = 90,
	CANCELLED = 100,
}

export enum SHIPMENT_EDIT_WINDOW {
	IN_PLACE_ADJUSTMENT = 'in_place_adjustment',
	ISSUE_AND_CLAIM_ADJUSTMENT = 'issue_and_claim_adjustment',
	NO_ADJUSTMENT = 'no_adjustment',
}

export enum SHIPMENT_STATUS_STRING {
	PENDING = 'Pending',
	ALLOCATED = 'Allocated',
	ONTHEROAD = 'On The Road',
	DELIVERED = 'Delivered',
	AWAITING = 'Awaiting',
	PAID = 'Paid',
}

export enum TRANSPORT_SHIPMENT_STATUS {
	PENDING = 'pending review',
	ALLOCATED = 'allocated',
	ALLOCATED_DELAYED = 'allocated-delayed',
	ALLOCATED_STARTED = 'allocated-started',
	PICKUP_DELAYED = 'pickup-delayed',
	PICKUP = 'on the road',
	DELIVERED_DELAYED = 'delivered delayed',
	DELIVERED = 'delivered',
	POD_RECEIVED_TO_CHECK = 'to check',
	POD_RECEIVED = 'pod-received',
	COMPLETED = 'complete',
	PAID = 'paid',
	CANCELLED = 'cancelled',
	ARCHIVED = 'archived'
}

export enum STATIC_ADMIN_SHIPMENT_STATUS {
	PENDING = 'admin/pending',
	ALLOCATED = 'admin/allocated',
	ONROAD = 'admin/onroad',
	DELIVERED = 'admin/delivered',
	CANCELLED = 'admin/cancelled',
}

export enum STATIC_SHIPPER_SHIPMENT_STATUS {
	PENDING = 'shipper/pending',
	ALLOCATED = 'shipper/allocated',
	ONROAD = 'shipper/onroad',
	DELIVERED = 'shipper/delivered',
	AWAITING = 'shipper/awaiting',
	PAID = 'shipper/paid',
	CANCELLED = 'shipper/cancelled',
}

export const statusStringToVal = (statusString: string): number => {
	switch (statusString) {
	case TRANSPORT_SHIPMENT_STATUS.PENDING:
		return SHIPMENT_STATUS.PENDING;
	case TRANSPORT_SHIPMENT_STATUS.ALLOCATED:
		return SHIPMENT_STATUS.ALLOCATED;
	case TRANSPORT_SHIPMENT_STATUS.PICKUP:
		return SHIPMENT_STATUS.PICKUP;
	case TRANSPORT_SHIPMENT_STATUS.DELIVERED:
		return SHIPMENT_STATUS.DELIVERED;
	case TRANSPORT_SHIPMENT_STATUS.POD_RECEIVED:
		return SHIPMENT_STATUS.POD_RECEIVED;
	case TRANSPORT_SHIPMENT_STATUS.COMPLETED:
		return SHIPMENT_STATUS.COMPLETE;
	case TRANSPORT_SHIPMENT_STATUS.PAID:
		return SHIPMENT_STATUS.PAID;
	case TRANSPORT_SHIPMENT_STATUS.CANCELLED:
		return SHIPMENT_STATUS.CANCELLED;
	case TRANSPORT_SHIPMENT_STATUS.ARCHIVED:
	default:
		return 0;
	}
}

export enum TRUCK_SIZE {
	RIGID = 'RIGID',
	SINGLE = 'SINGLE',
	A_DOUBLE = 'A_DOUBLE',
	B_DOUBLE = 'B_DOUBLE',
	SKELETON = 'SKELETON',
	SIDELOADER = 'SIDELOADER',
	B_DOUBLE_HIGH_CUBE = 'B_DOUBLE_HIGH_CUBE',
	CONTAINER_20FT_COASTAL = 'CONTAINER_20FT_COASTAL',
	CONTAINER_40FT_COASTAL = 'CONTAINER_40FT_COASTAL',
	CONTAINER_46FT_COASTAL = 'CONTAINER_46FT_COASTAL',
	CONTAINER_48FT_COASTAL = 'CONTAINER_48FT_COASTAL',
	B_TRIPLE = 'B_TRIPLE',
	SUPER_B_DOUBLE = 'SUPER_B_DOUBLE',
}

export enum RATE_CARD_TRUCK_SIZE {
	SINGLE = 'SINGLE',
	RIGID = 'RIGID',
	A_DOUBLE = 'A_DOUBLE',
	B_DOUBLE = 'B_DOUBLE',
	B_DOUBLE_HIGH_CUBE = 'B_DOUBLE_HIGH_CUBE',
	CONTAINER_20_FT_COASTAL = 'CONTAINER_20_FT_COASTAL',
	CONTAINER_40_FT_COASTAL = 'CONTAINER_40_FT_COASTAL',
	CONTAINER_46_FT_COASTAL = 'CONTAINER_46_FT_COASTAL',
	CONTAINER_48_FT_COASTAL = 'CONTAINER_48_FT_COASTAL',
	B_TRIPLE = 'B_TRIPLE',
	SUPER_B_DOUBLE = 'SUPER_B_DOUBLE',
}

export enum TRUCK_TYPE {
	ANY = 'ANY',
	TAUTLINER = 'TAUTLINER',
	PANTECH = 'PANTECH',
	FLAT_TOP = 'FLAT_TOP',
	TAUTLINER_STRAIGHT_DECK = 'TAUTLINER_STRAIGHT_DECK',
	TAUTLINER_DROP_DECK = 'TAUTLINER_DROP_DECK',
	TAUTLINER_MEZZANINE_DECK = 'TAUTLINER_MEZZANINE_DECK',
	SIDELOADER = 'SIDELOADER',
	SKELETON = 'SKELETON_TRAILER',
	OPEN_TOP = 'OPEN_TOP',
	UTE = 'UTE',
	TIPPER = 'TIPPER'
}

export enum FREIGHT_MODE {
	ROAD = 'ROAD',
	RAIL = 'RAIL',
	COASTAL = 'COASTAL',
}

export enum FREIGHT_MODE_LABELS {
	ROAD = 'Road',
	COASTAL = 'Coastal',
	RAIL = 'Rail',
}

export enum RATE_CARD_ROLES {
	SHIPPER_RATE_CARD_MANAGER = 'shipper ratecard manager',
	CARRIER_RATE_CARD_MANAGER = 'carrier ratecard manager',
	ADMIN_RATECARD_MANAGER = 'admin ratecard manager',
}

export const IC_CREATOR_ROLES: string[] = [
	'super_admin',
	'finance',
	'finance_team',
	'operations',
	'operation manager',
	'transport manager',
];

export enum USER_PERMISSION {
	LINEHAUL_MANAGER = 'linehaul manager',
	FEATURE_FLAG_MANAGER = 'feature flag manager',
	FEATURE_FLAG_DEVELOPER = 'feature flag developer',
	DEMURRAGE_RATECARD_MANAGER = 'demurrage ratecard manager',
	BULK_ISSUE_AND_CLAIM_AUTO_APPROVER = 'bulk issue and claim auto approver',
	BULK_ACTIVE_RATE_CARDS_DELETER = 'bulk active rate cards deleter',
}

export enum USER_ROLE {
	FINANCE = 'finance',
	ADMIN = 'admin',
	SUPER_ADMIN = 'super_admin',
}

export enum RATE_CARD_MODIFIERS {
	TRUCK1 = 'Tautliner',
	TRUCK2 = 'Pantech',
	TRUCK3 = 'Flat Top',
	TRUCK4 = 'Tautliner Straight Deck',
	TRUCK5 = 'Tautliner Drop Deck',
	TRUCK6 = 'Tautliner Mezzanine Deck',
	TRUCK7 = 'Sideloader',
	TRUCK8 = 'Skeleton Trailer',
	TRUCK9 = 'Open Top',
	TRUCK10 = 'Tipper',
}

export const COUNTRY_CODES = {
	AF: ['Afghanistan', 'AF', '93'],
	AL: ['Albania', 'AL', '355'],
	DZ: ['Algeria', 'DZ', '213'],
	AD: ['Andorra', 'AD', '376'],
	AO: ['Angola', 'AO', '244'],
	AG: ['Antigua and Barbuda', 'AG', '1268'],
	AR: ['Argentina', 'AR', '54', '(..) ........', 0],
	AM: ['Armenia', 'AM', '374', '.. ......'],
	AW: ['Aruba', 'AW', '297'],
	AU: ['Australia', 'AU', '61', '(..) .... ....'],
	AS: ['American Samoa', 'AS', '1'],
	AT: ['Austria', 'AT', '43'],
	AZ: ['Azerbaijan', 'AZ', '994', '(..) ... .. ..'],
	BS: ['Bahamas', 'BS', '1242'],
	BH: ['Bahrain', 'BH', '973'],
	BD: ['Bangladesh', 'BD', '880'],
	BB: ['Barbados', 'BB', '1246'],
	BY: ['Belarus', 'BY', '375', '(..) ... .. ..'],
	BE: ['Belgium', 'BE', '32', '... .. .. ..'],
	BZ: ['Belize', 'BZ', '501'],
	BJ: ['Benin', 'BJ', '229'],
	BT: ['Bhutan', 'BT', '975'],
	BO: ['Bolivia', 'BO', '591'],
	BA: ['Bosnia and Herzegovina', 'BA', '387'],
	BW: ['Botswana', 'BW', '267'],
	BR: ['Brazil', 'BR', '55', '(..) .........'],
	IO: ['British Indian Ocean Territory', 'IO', '246'],
	BN: ['Brunei', 'BN', '673'],
	BG: ['Bulgaria', 'BG', '359'],
	BF: ['Burkina Faso', 'BF', '226'],
	BI: ['Burundi', 'BI', '257'],
	KH: ['Cambodia', 'KH', '855'],
	CM: ['Cameroon', 'CM', '237'],
	CA: ['Canada', 'CA', '1', '(...) ...-....'],
	CV: ['Cape Verde', 'CV', '238'],
	BQ: ['Caribbean Netherlands', 'BQ', '599', '', 1],
	CF: ['Central African Republic', 'CF', '236'],
	TD: ['Chad', 'TD', '235'],
	CL: ['Chile', 'CL', '56'],
	CN: ['China', 'CN', '86', '..-.........'],
	CO: ['Colombia', 'CO', '57', '... ... ....'],
	KM: ['Comoros', 'KM', '269'],
	CD: ['Congo', 'CD', '243'],
	CG: ['Congo', 'CG', '242'],
	CR: ['Costa Rica', 'CR', '506', '....-....'],
	CI: ['Côte d’Ivoire', 'CI', '225', '.. .. .. ..'],
	HR: ['Croatia', 'HR', '385'],
	CU: ['Cuba', 'CU', '53'],
	CW: ['Curaçao', 'CW', '599', '', 0],
	CY: ['Cyprus', 'CY', '357', '.. ......'],
	CZ: ['Czech Republic', 'CZ', '420', '... ... ...'],
	DK: ['Denmark', 'DK', '45', '.. .. .. ..'],
	DJ: ['Djibouti', 'DJ', '253'],
	DM: ['Dominica', 'DM', '1767'],
	DO: ['Dominican Republic', 'DO', '1', ''],
	EC: ['Ecuador', 'EC', '593'],
	EG: ['Egypt', 'EG', '20'],
	SV: ['El Salvador', 'SV', '503', '....-....'],
	GQ: ['Equatorial Guinea', 'GQ', '240'],
	ER: ['Eritrea', 'ER', '291'],
	EE: ['Estonia', 'EE', '372', '.... ......'],
	ET: ['Ethiopia', 'ET', '251'],
	FJ: ['Fiji', 'FJ', '679'],
	FI: ['Finland', 'FI', '358', '.. ... .. ..'],
	FR: ['France', 'FR', '33', '. .. .. .. ..'],
	GF: ['French Guiana', 'GF', '594'],
	PF: ['French Polynesia', 'PF', '689'],
	GA: ['Gabon', 'GA', '241'],
	GM: ['Gambia', 'GM', '220'],
	GE: ['Georgia', 'GE', '995'],
	DE: ['Germany', 'DE', '49', '.... ........'],
	GH: ['Ghana', 'GH', '233'],
	GR: ['Greece', 'GR', '30'],
	GD: ['Grenada', 'GD', '1473'],
	GP: ['Guadeloupe', 'GP', '590', '', 0],
	GU: ['Guam', 'GU', '1671'],
	GT: ['Guatemala', 'GT', '502', '....-....'],
	GN: ['Guinea', 'GN', '224'],
	GW: ['Guinea-Bissau', 'GW', '245'],
	GY: ['Guyana', 'GY', '592'],
	HT: ['Haiti', 'HT', '509', '....-....'],
	HN: ['Honduras', 'HN', '504'],
	HK: ['Hong Kong', 'HK', '852', '.... ....'],
	HU: ['Hungary', 'HU', '36'],
	IS: ['Iceland', 'IS', '354', '... ....'],
	IN: ['India', 'IN', '91', '.....-.....'],
	ID: ['Indonesia', 'ID', '62'],
	IR: ['Iran', 'IR', '98', '... ... ....'],
	IQ: ['Iraq', 'IQ', '964'],
	IE: ['Ireland', 'IE', '353', '.. .......'],
	IL: ['Israel', 'IL', '972', '... ... ....'],
	IT: ['Italy', 'IT', '39', '... .......', 0],
	JM: ['Jamaica', 'JM', '1876'],
	JP: ['Japan', 'JP', '81', '.. .... ....'],
	JO: ['Jordan', 'JO', '962'],
	KZ: ['Kazakhstan', 'KZ', '7', '... ...-..-..'],
	KE: ['Kenya', 'KE', '254'],
	KI: ['Kiribati', 'KI', '686'],
	XK: ['Kosovo', 'XK', '383'],
	KW: ['Kuwait', 'KW', '965'],
	KG: ['Kyrgyzstan', 'KG', '996', '... ... ...'],
	LA: ['Laos', 'LA', '856'],
	LV: ['Latvia', 'LV', '371', '.. ... ...'],
	LB: ['Lebanon', 'LB', '961'],
	LS: ['Lesotho', 'LS', '266'],
	LR: ['Liberia', 'LR', '231'],
	LY: ['Libya', 'LY', '218'],
	LI: ['Liechtenstein', 'LI', '423'],
	LT: ['Lithuania', 'LT', '370'],
	LU: ['Luxembourg', 'LU', '352'],
	MO: ['Macau', 'MO', '853'],
	MK: ['Macedonia', 'MK', '389'],
	MG: ['Madagascar', 'MG', '261'],
	MW: ['Malawi', 'MW', '265'],
	MY: ['Malaysia', 'MY', '60', '..-....-....'],
	MV: ['Maldives', 'MV', '960'],
	ML: ['Mali', 'ML', '223'],
	MT: ['Malta', 'MT', '356'],
	MH: ['Marshall Islands', 'MH', '692'],
	MQ: ['Martinique', 'MQ', '596'],
	MR: ['Mauritania', 'MR', '222'],
	MU: ['Mauritius', 'MU', '230'],
	MX: ['Mexico', 'MX', '52', '... ... ....'],
	FM: ['Micronesia', 'FM', '691'],
	MD: ['Moldova', 'MD', '373', '(..) ..-..-..'],
	MC: ['Monaco', 'MC', '377'],
	MN: ['Mongolia', 'MN', '976'],
	ME: ['Montenegro', 'ME', '382'],
	MA: ['Morocco', 'MA', '212'],
	MZ: ['Mozambique', 'MZ', '258'],
	MM: ['Myanmar', 'MM', '95'],
	NA: ['Namibia', 'NA', '264'],
	NR: ['Nauru', 'NR', '674'],
	NP: ['Nepal', 'NP', '977'],
	NL: ['Netherlands', 'NL', '31', '.. ........'],
	NC: ['New Caledonia', 'NC', '687'],
	NZ: ['New Zealand', 'NZ', '64', '...-...-....'],
	NI: ['Nicaragua', 'NI', '505'],
	NE: ['Niger', 'NE', '227'],
	NG: ['Nigeria', 'NG', '234'],
	KP: ['North Korea', 'KP', '850'],
	NO: ['Norway', 'NO', '47', '... .. ...'],
	OM: ['Oman', 'OM', '968'],
	PK: ['Pakistan', 'PK', '92', '...-.......'],
	PW: ['Palau', 'PW', '680'],
	PS: ['Palestine', 'PS', '970'],
	PA: ['Panama', 'PA', '507'],
	PG: ['Papua New Guinea', 'PG', '675'],
	PY: ['Paraguay', 'PY', '595'],
	PE: ['Peru', 'PE', '51'],
	PH: ['Philippines', 'PH', '63', '.... .......'],
	PL: ['Poland', 'PL', '48', '...-...-...'],
	PT: ['Portugal', 'PT', '351'],
	PR: ['Puerto Rico', 'PR', '1', ''],
	QA: ['Qatar', 'QA', '974'],
	RE: ['Réunion', 'RE', '262'],
	RO: ['Romania', 'RO', '40'],
	RU: ['Russia', 'RU', '7', '(...) ...-..-..', 0],
	RW: ['Rwanda', 'RW', '250'],
	KN: ['Saint Kitts and Nevis', 'KN', '1869'],
	LC: ['Saint Lucia', 'LC', '1758'],
	VC: ['Saint Vincent and the Grenadines', 'VC', '1784'],
	WS: ['Samoa', 'WS', '685'],
	SM: ['San Marino', 'SM', '378'],
	ST: ['São Tomé and Príncipe', 'ST', '239'],
	SA: ['Saudi Arabia', 'SA', '966'],
	SN: ['Senegal', 'SN', '221'],
	RS: ['Serbia', 'RS', '381'],
	SC: ['Seychelles', 'SC', '248'],
	SL: ['Sierra Leone', 'SL', '232'],
	SG: ['Singapore', 'SG', '65', '....-....'],
	SK: ['Slovakia', 'SK', '421'],
	SI: ['Slovenia', 'SI', '386'],
	SB: ['Solomon Islands', 'SB', '677'],
	SO: ['Somalia', 'SO', '252'],
	ZA: ['South Africa', 'ZA', '27'],
	KR: ['South Korea', 'KR', '82', '... .... ....'],
	SS: ['South Sudan', 'SS', '211'],
	ES: ['Spain', 'ES', '34', '... ... ...'],
	LK: ['Sri Lanka', 'LK', '94'],
	SD: ['Sudan', 'SD', '249'],
	SR: ['Suriname', 'SR', '597'],
	SZ: ['Swaziland', 'SZ', '268'],
	SE: ['Sweden', 'SE', '46', '(...) ...-...'],
	CH: ['Switzerland', 'CH', '41', '.. ... .. ..'],
	SY: ['Syria', 'SY', '963'],
	TW: ['Taiwan', 'TW', '886'],
	TJ: ['Tajikistan', 'TJ', '992'],
	TZ: ['Tanzania', 'TZ', '255'],
	TH: ['Thailand', 'TH', '66'],
	TL: ['Timor-Leste', 'TL', '670'],
	TG: ['Togo', 'TG', '228'],
	TO: ['Tonga', 'TO', '676'],
	TT: ['Trinidad and Tobago', 'TT', '1868'],
	TN: ['Tunisia', 'TN', '216'],
	TR: ['Turkey', 'TR', '90', '... ... .. ..'],
	TM: ['Turkmenistan', 'TM', '993'],
	TV: ['Tuvalu', 'TV', '688'],
	UG: ['Uganda', 'UG', '256'],
	UA: ['Ukraine', 'UA', '380', '(..) ... .. ..'],
	AE: ['United Arab Emirates', 'AE', '971'],
	GB: ['United Kingdom', 'GB', '44', '.... ......'],
	US: ['United States', 'US', '1', '(...) ...-....'],
	UY: ['Uruguay', 'UY', '598'],
	UZ: ['Uzbekistan', 'UZ', '998', '.. ... .. ..'],
	VU: ['Vanuatu', 'VU', '678'],
	VA: ['Vatican City', 'VA', '39', '.. .... ....', 1],
	VE: ['Venezuela', 'VE', '58'],
	VN: ['Vietnam', 'VN', '84'],
	YE: ['Yemen', 'YE', '967'],
	ZM: ['Zambia', 'ZM', '260'],
	ZW: ['Zimbabwe', 'ZW', '263'],
};

export const TIMEZONE_OPTS = [
	{
		value: 'Pacific/Midway',
		label: '(GMT-11:00) Midway Island, Samoa',
		offset: -11,
		abbrev: 'SST',
		altName: 'Samoa Standard Time',
		id: 0,
	},
	{
		value: 'Pacific/Honolulu',
		label: '(GMT-10:00) Hawaii',
		offset: -10,
		abbrev: 'HAST',
		altName: 'Hawaii-Aleutian Standard Time',
		id: 1,
	},
	{
		value: 'America/Juneau',
		label: '(GMT-8:00) Alaska',
		offset: -8,
		abbrev: 'AKDT',
		altName: 'Alaska Daylight Time',
		id: 2,
	},
	{
		value: 'America/Dawson',
		label: '(GMT-7:00) Dawson, Yukon',
		offset: -7,
		abbrev: 'MST',
		altName: 'Mountain Standard Time',
		id: 3,
	},
	{
		value: 'America/Phoenix',
		label: '(GMT-7:00) Arizona',
		offset: -7,
		abbrev: 'MST',
		altName: 'Mountain Standard Time',
		id: 4,
	},
	{
		value: 'America/Tijuana',
		label: '(GMT-7:00) Tijuana',
		offset: -7,
		abbrev: 'PDT',
		altName: 'Pacific Daylight Time',
		id: 5,
	},
	{
		value: 'America/Los_Angeles',
		label: '(GMT-7:00) Pacific Time',
		offset: -7,
		abbrev: 'PDT',
		altName: 'Pacific Daylight Time',
		id: 6,
	},
	{
		value: 'America/Boise',
		label: '(GMT-6:00) Mountain Time',
		offset: -6,
		abbrev: 'MDT',
		altName: 'Mountain Daylight Time',
		id: 7,
	},
	{
		value: 'America/Chihuahua',
		label: '(GMT-6:00) Chihuahua, La Paz, Mazatlan',
		offset: -6,
		abbrev: 'HNPMX',
		altName: 'Mexican Pacific Standard Time',
		id: 8,
	},
	{
		value: 'America/Regina',
		label: '(GMT-6:00) Saskatchewan',
		offset: -6,
		abbrev: 'CST',
		altName: 'Central Standard Time',
		id: 9,
	},
	{
		value: 'America/Mexico_City',
		label: '(GMT-6:00) Guadalajara, Mexico City, Monterrey',
		offset: -6,
		abbrev: 'CST',
		altName: 'Central Mexico Standard Time',
		id: 10,
	},
	{
		value: 'America/Belize',
		label: '(GMT-6:00) Central America',
		offset: -6,
		abbrev: 'CST',
		altName: 'Central Standard Time',
		id: 11,
	},
	{
		value: 'America/Chicago',
		label: '(GMT-5:00) Central Time',
		offset: -5,
		abbrev: 'CDT',
		altName: 'Central Daylight Time',
		id: 12,
	},
	{
		value: 'America/Bogota',
		label: '(GMT-5:00) Bogota, Lima, Quito',
		offset: -5,
		abbrev: 'COT',
		altName: 'Colombia Standard Time',
		id: 13,
	},
	{
		value: 'America/Detroit',
		label: '(GMT-4:00) Eastern Time',
		offset: -4,
		abbrev: 'EDT',
		altName: 'Eastern Daylight Time',
		id: 14,
	},
	{
		value: 'America/Caracas',
		label: '(GMT-4:00) Caracas, La Paz',
		offset: -4,
		abbrev: 'VET',
		altName: 'Venezuela Standard Time',
		id: 15,
	},
	{
		value: 'America/Santiago',
		label: '(GMT-4:00) Santiago',
		offset: -4,
		abbrev: 'CLT',
		altName: 'Chile Standard Time',
		id: 16,
	},
	{
		value: 'America/Sao_Paulo',
		label: '(GMT-3:00) Brasilia',
		offset: -3,
		abbrev: 'BRT',
		altName: 'Brasilia Standard Time',
		id: 17,
	},
	{
		value: 'America/Montevideo',
		label: '(GMT-3:00) Montevideo',
		offset: -3,
		abbrev: 'UYT',
		altName: 'Uruguay Standard Time',
		id: 18,
	},
	{
		value: 'America/Argentina/Buenos_Aires',
		label: '(GMT-3:00) Buenos Aires, Georgetown',
		offset: -3,
		abbrev: 'ART',
		altName: 'Argentina Standard Time',
		id: 19,
	},
	{
		value: 'America/St_Johns',
		label: '(GMT-2:30) Newfoundland and Labrador',
		offset: -2.5,
		abbrev: 'HETN',
		altName: 'Newfoundland Daylight Time',
		id: 20,
	},
	{
		value: 'America/Godthab',
		label: '(GMT-2:00) Greenland',
		offset: -2,
		abbrev: 'WGST',
		altName: 'West Greenland Summer Time',
		id: 21,
	},
	{
		value: 'Atlantic/Cape_Verde',
		label: '(GMT-1:00) Cape Verde Islands',
		offset: -1,
		abbrev: 'CVT',
		altName: 'Cape Verde Standard Time',
		id: 22,
	},
	{
		value: 'Atlantic/Azores',
		label: '(GMT+0:00) Azores',
		offset: 0,
		abbrev: 'AZOST',
		altName: 'Azores Summer Time',
		id: 23,
	},
	{
		value: 'Etc/GMT',
		label: '(GMT+0:00) UTC',
		offset: 0,
		abbrev: 'GMT',
		altName: 'British Standard Time',
		id: 24,
	},
	{
		value: 'Europe/London',
		label: '(GMT+1:00) Edinburgh, London',
		offset: 1,
		abbrev: 'BST',
		altName: 'British Summer Time',
		id: 25,
	},
	{
		value: 'Europe/Dublin',
		label: '(GMT+1:00) Dublin',
		offset: 1,
		abbrev: 'IST',
		altName: 'Irish Standard Time',
		id: 26,
	},
	{
		value: 'Europe/Lisbon',
		label: '(GMT+1:00) Lisbon',
		offset: 1,
		abbrev: 'WEST',
		altName: 'Western European Summer Time',
		id: 27,
	},
	{
		value: 'Africa/Casablanca',
		label: '(GMT+1:00) Casablanca, Monrovia',
		offset: 1,
		abbrev: 'WEST',
		altName: 'Western European Summer Time',
		id: 28,
	},
	{
		value: 'Atlantic/Canary',
		label: '(GMT+1:00) Canary Islands',
		offset: 1,
		abbrev: 'WEST',
		altName: 'Western European Summer Time',
		id: 29,
	},
	{
		value: 'Africa/Algiers',
		label: '(GMT+1:00) West Central Africa',
		offset: 1,
		abbrev: 'CET',
		altName: 'Central European Standard Time',
		id: 30,
	},
	{
		value: 'Europe/Belgrade',
		label: '(GMT+2:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
		offset: 2,
		abbrev: 'CEST',
		altName: 'Central European Summer Time',
		id: 31,
	},
	{
		value: 'Europe/Sarajevo',
		label: '(GMT+2:00) Sarajevo, Skopje, Warsaw, Zagreb',
		offset: 2,
		abbrev: 'CEST',
		altName: 'Central European Summer Time',
		id: 32,
	},
	{
		value: 'Europe/Brussels',
		label: '(GMT+2:00) Brussels, Copenhagen, Madrid, Paris',
		offset: 2,
		abbrev: 'CEST',
		altName: 'Central European Summer Time',
		id: 33,
	},
	{
		value: 'Europe/Amsterdam',
		label: '(GMT+2:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
		offset: 2,
		abbrev: 'CEST',
		altName: 'Central European Summer Time',
		id: 34,
	},
	{
		value: 'Africa/Cairo',
		label: '(GMT+2:00) Cairo',
		offset: 2,
		abbrev: 'EET',
		altName: 'Eastern European Standard Time',
		id: 35,
	},
	{
		value: 'Africa/Harare',
		label: '(GMT+2:00) Harare, Pretoria',
		offset: 2,
		abbrev: 'CAT',
		altName: 'Central Africa Standard Time',
		id: 36,
	},
	{
		value: 'Europe/Bucharest',
		label: '(GMT+3:00) Bucharest',
		offset: 3,
		abbrev: 'EEST',
		altName: 'Eastern European Summer Time',
		id: 37,
	},
	{
		value: 'Europe/Helsinki',
		label: '(GMT+3:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
		offset: 3,
		abbrev: 'EEST',
		altName: 'Eastern European Summer Time',
		id: 38,
	},
	{
		value: 'Europe/Athens',
		label: '(GMT+3:00) Athens',
		offset: 3,
		abbrev: 'EEST',
		altName: 'Eastern European Summer Time',
		id: 39,
	},
	{
		value: 'Asia/Jerusalem',
		label: '(GMT+3:00) Jerusalem',
		offset: 3,
		abbrev: 'IDT',
		altName: 'Israel Daylight Time',
		id: 40,
	},
	{
		value: 'Europe/Moscow',
		label: '(GMT+3:00) Istanbul, Minsk, Moscow, St. Petersburg, Volgograd',
		offset: 3,
		abbrev: 'MSK',
		altName: 'Moscow Standard Time',
		id: 41,
	},
	{
		value: 'Asia/Kuwait',
		label: '(GMT+3:00) Kuwait, Riyadh',
		offset: 3,
		abbrev: 'AST',
		altName: 'Arabian Standard Time',
		id: 42,
	},
	{
		value: 'Africa/Nairobi',
		label: '(GMT+3:00) Nairobi',
		offset: 3,
		abbrev: 'EAT',
		altName: 'East Africa Standard Time',
		id: 43,
	},
	{
		value: 'Asia/Baghdad',
		label: '(GMT+3:00) Baghdad',
		offset: 3,
		abbrev: 'AST',
		altName: 'Arabian Standard Time',
		id: 44,
	},
	{
		value: 'Asia/Tehran',
		label: '(GMT+3:30) Tehran',
		offset: 3.5,
		abbrev: 'IRST',
		altName: 'Iran Standard Time',
		id: 45,
	},
	{
		value: 'Asia/Dubai',
		label: '(GMT+4:00) Abu Dhabi, Muscat',
		offset: 4,
		abbrev: 'GST',
		altName: 'Gulf Standard Time',
		id: 46,
	},
	{
		value: 'Asia/Baku',
		label: '(GMT+4:00) Baku, Tbilisi, Yerevan',
		offset: 4,
		abbrev: 'AZT',
		altName: 'Azerbaijan Standard Time',
		id: 47,
	},
	{
		value: 'Asia/Kabul',
		label: '(GMT+4:30) Kabul',
		offset: 4.5,
		abbrev: 'AFT',
		altName: 'Afghanistan Standard Time',
		id: 48,
	},
	{
		value: 'Asia/Yekaterinburg',
		label: '(GMT+5:00) Ekaterinburg',
		offset: 5,
		abbrev: 'YEKT',
		altName: 'Yekaterinburg Standard Time',
		id: 49,
	},
	{
		value: 'Asia/Karachi',
		label: '(GMT+5:00) Islamabad, Karachi, Tashkent',
		offset: 5,
		abbrev: 'PKT',
		altName: 'Pakistan Standard Time',
		id: 50,
	},
	{
		value: 'Asia/Kolkata',
		label: '(GMT+5:30) Chennai, Kolkata, Mumbai, New Delhi',
		offset: 5.5,
		abbrev: 'IST',
		altName: 'India Standard Time',
		id: 51,
	},
	{
		value: 'Asia/Colombo',
		label: '(GMT+5:30) Sri Jayawardenepura',
		offset: 5.5,
		abbrev: 'IST',
		altName: 'India Standard Time',
		id: 52,
	},
	{
		value: 'Asia/Kathmandu',
		label: '(GMT+5:45) Kathmandu',
		offset: 5.75,
		abbrev: 'NPT',
		altName: 'Nepal Standard Time',
		id: 53,
	},
	{
		value: 'Asia/Dhaka',
		label: '(GMT+6:00) Astana, Dhaka',
		offset: 6,
		abbrev: 'BST',
		altName: 'Bangladesh Standard Time',
		id: 54,
	},
	{
		value: 'Asia/Almaty',
		label: '(GMT+6:00) Almaty, Novosibirsk',
		offset: 6,
		abbrev: 'ALMT',
		altName: 'East Kazakhstan Standard Time',
		id: 55,
	},
	{
		value: 'Asia/Rangoon',
		label: '(GMT+6:30) Yangon Rangoon',
		offset: 6.5,
		abbrev: 'MMT',
		altName: 'Myanmar Standard Time',
		id: 56,
	},
	{
		value: 'Asia/Bangkok',
		label: '(GMT+7:00) Bangkok, Hanoi, Jakarta',
		offset: 7,
		abbrev: 'ICT',
		altName: 'Indochina Standard Time',
		id: 57,
	},
	{
		value: 'Asia/Krasnoyarsk',
		label: '(GMT+7:00) Krasnoyarsk',
		offset: 7,
		abbrev: 'KRAT',
		altName: 'Krasnoyarsk Standard Time',
		id: 58,
	},
	{
		value: 'Asia/Shanghai',
		label: '(GMT+8:00) Beijing, Chongqing, Hong Kong SAR, Urumqi',
		offset: 8,
		abbrev: 'CST',
		altName: 'China Standard Time',
		id: 59,
	},
	{
		value: 'Asia/Kuala_Lumpur',
		label: '(GMT+8:00) Kuala Lumpur, Singapore',
		offset: 8,
		abbrev: 'MYT',
		altName: 'Malaysia Standard Time',
		id: 60,
	},
	{
		value: 'Asia/Taipei',
		label: '(GMT+8:00) Taipei',
		offset: 8,
		abbrev: 'CST',
		altName: 'Taipei Standard Time',
		id: 61,
	},
	{
		value: 'Australia/Perth',
		label: '(GMT+8:00) Perth',
		offset: 8,
		abbrev: 'AWST',
		altName: 'Western Australia Standard Time',
		id: 62,
	},
	{
		value: 'Asia/Irkutsk',
		label: '(GMT+8:00) Irkutsk, Ulaanbaatar',
		offset: 8,
		abbrev: 'IRKT',
		altName: 'Irkutsk Standard Time',
		id: 63,
	},
	{
		value: 'Asia/Seoul',
		label: '(GMT+9:00) Seoul',
		offset: 9,
		abbrev: 'KST',
		altName: 'Korean Standard Time',
		id: 64,
	},
	{
		value: 'Asia/Tokyo',
		label: '(GMT+9:00) Osaka, Sapporo, Tokyo',
		offset: 9,
		abbrev: 'JST',
		altName: 'Japan Standard Time',
		id: 65,
	},
	{
		value: 'Asia/Yakutsk',
		label: '(GMT+9:00) Yakutsk',
		offset: 9,
		abbrev: 'YAKT',
		altName: 'Yakutsk Standard Time',
		id: 66,
	},
	{
		value: 'Australia/Darwin',
		label: '(GMT+9:30) Darwin',
		offset: 9.5,
		abbrev: 'ACST',
		altName: 'Australian Central Standard Time',
		id: 67,
	},
	{
		value: 'Australia/Adelaide',
		label: '(GMT+9:30) Adelaide',
		offset: 9.5,
		abbrev: 'ACST',
		altName: 'Central Australia Standard Time',
		id: 68,
	},
	{
		value: 'Australia/Sydney',
		label: '(GMT+10:00) Canberra, Melbourne, Sydney',
		offset: 10,
		abbrev: 'AEST',
		altName: 'Eastern Australia Standard Time',
		id: 69,
	},
	{
		value: 'Australia/Brisbane',
		label: '(GMT+10:00) Brisbane',
		offset: 10,
		abbrev: 'AEST',
		altName: 'Brisbane Standard Time',
		id: 70,
	},
	{
		value: 'Australia/Hobart',
		label: '(GMT+10:00) Hobart',
		offset: 10,
		abbrev: 'AEST',
		altName: 'Eastern Australia Standard Time',
		id: 71,
	},
	{
		value: 'Asia/Vladivostok',
		label: '(GMT+10:00) Vladivostok',
		offset: 10,
		abbrev: 'VLAT',
		altName: 'Vladivostok Standard Time',
		id: 72,
	},
	{
		value: 'Pacific/Guam',
		label: '(GMT+10:00) Guam, Port Moresby',
		offset: 10,
		abbrev: 'ChST',
		altName: 'Chamorro Standard Time',
		id: 73,
	},
	{
		value: 'Asia/Magadan',
		label: '(GMT+11:00) Magadan, Solomon Islands, New Caledonia',
		offset: 11,
		abbrev: 'MAGT',
		altName: 'Magadan Standard Time',
		id: 74,
	},
	{
		value: 'Asia/Kamchatka',
		label: '(GMT+12:00) Kamchatka, Marshall Islands',
		offset: 12,
		abbrev: 'PETT',
		altName: 'Petropavlovsk-Kamchatski Standard Time',
		id: 75,
	},
	{
		value: 'Pacific/Fiji',
		label: '(GMT+12:00) Fiji Islands',
		offset: 12,
		abbrev: 'FJT',
		altName: 'Fiji Standard Time',
		id: 76,
	},
	{
		value: 'Pacific/Auckland',
		label: '(GMT+12:00) Auckland, Wellington',
		offset: 12,
		abbrev: 'NZST',
		altName: 'New Zealand Standard Time',
		id: 77,
	},
	{
		value: 'Pacific/Tongatapu',
		label: "(GMT+13:00) Nuku'alofa",
		offset: 13,
		abbrev: 'TOT',
		altName: 'Tonga Standard Time',
		id: 78,
	},
];

export const DAYS = [
	{
		value: 0,
		label: 'Sunday',
	},
	{
		value: 1,
		label: 'Monday',
	},
	{
		value: 2,
		label: 'Tuesday',
	},
	{
		value: 3,
		label: 'Wednesday',
	},
	{
		value: 4,
		label: 'Thursday',
	},
	{
		value: 5,
		label: 'Friday',
	},
	{
		value: 6,
		label: 'Saturday',
	},
];
export const MONTH_NAMES = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
]

export const InvoiceStatus = {
	Rejected: 'Rejected',
	Approved: 'Approved',
	UnderInvestigation: 'Under Investigation',
	Pending: 'Pending',
	Review: 'Review',
	ApprovedPendingPod: 'Approved - Pending POD'
}

export enum NONRCTIVIEW {
	APPROVE = 'APPROVE',
	REJECT = 'REJECT',
	REVIEW = 'REVIEW',
	/*  APP-5183 Hiding until BE is ready
	   APPROVED_PENDING_POD = 'APPROVED_PENDING_POD', */
	ALL = 'ALL'
}

export enum NON_RCTI_STATUS_ACTION {
	APPROVE = 'approve',
	REJECT = 'reject',
	REVIEW = 'review',
	/*  APP-5183 Hiding until BE is ready
	   APPROVED_PENDING_POD = 'approved_pending_pod' */
}

export enum SHIPPER_EXTRA_CARE_MODES {
	GO_LIVE = 'go_live',
	HYPER_CARE = 'hyper_care',
	NONE = 'none'
}
export const getShipperCareLabel = (mode: SHIPPER_EXTRA_CARE_MODES | string | null): string => {
	switch (mode) {
	case SHIPPER_EXTRA_CARE_MODES.HYPER_CARE:
		return 'Hyper Care';
	case SHIPPER_EXTRA_CARE_MODES.GO_LIVE:
		return 'Go Live';
	case SHIPPER_EXTRA_CARE_MODES.NONE:
		return 'None';
	default:
		return ''
	}
}
export enum SHIPPER_LABEL_TYPE {
	HEADING = 'heading',
	LINK = 'link'
}

export enum RATE_CARD_RANGE_METRIC {
	PALLETS = 'Pallets',
	WEIGHT = 'Kilograms',
	VOLUME = 'Cubic-Metres',
	HOURS = 'Hours',
	DISTANCE = 'Kilometres',
	ITEM = 'Items',
}

export enum INVOICE_FUNDING_STATUS {
	NOT_STARTED = 'not_started',
	ACTIVE = 'active',
	PENDING = 'pending',
	PENDING_ACTIVATION = 'pending-activation',
	INACTIVE = 'inactive',
}

export enum BUTN_PAY_OPTION {
	FAST_PAY = 'fastPay',
	PAY_LATER = 'payLater',
}

export const DEFAULT_RATE_CARD_RANGES = {
	PALLETS: [
		{
			start: 0,
			end: 5,
		},
		{
			start: 6,
			end: 10,
		},
		{
			start: 11,
			end: 15,
		},
		{
			start: 16,
			end: 25,
		},
	],
	WEIGHT: [
		{
			start: 0,
			end: 500,
		},
		{
			start: 501,
			end: 1000,
		},
		{
			start: 1001,
			end: 2000,
		},
		{
			start: 2001,
			end: 4000,
		},
	],
	CPK: [
		{
			start: 0,
			end: 100,
		},
		{
			start: 101,
			end: 300,
		},
		{
			start: 301,
			end: 500,
		},
		{
			start: 501,
			end: 40000,
		},
	],
	FULL_LOAD: [],
	ITEM: []
}
export enum TruckSizes {
	RIGID = TRUCK_OPTIONS.RIGID,
	SINGLE = TRUCK_OPTIONS.SINGLE,
	A_DOUBLE = TRUCK_OPTIONS.A_DOUBLE,
	B_DOUBLE = TRUCK_OPTIONS.B_DOUBLE,
	B_DOUBLE_HIGH_CUBE = TRUCK_OPTIONS.B_DOUBLE_HIGH_CUBE,
	CONTAINER_20_FT_COASTAL = TRUCK_OPTIONS.FT20_CONTAINER,
	CONTAINER_40_FT_COASTAL = TRUCK_OPTIONS.FT40_CONTAINER,
	CONTAINER_46_FT_COASTAL = '46ft Container',
	CONTAINER_48_FT_COASTAL = '48ft Container',
	SUPER_B_DOUBLE = TRUCK_OPTIONS.SUPER_B_DOUBLE,
	B_TRIPLE = TRUCK_OPTIONS.B_TRIPLE,
}

export enum ACCESS_LEVELS {
	ADMIN = 100,
	FINANCE = 200,
	MANAGER = 300,
	OPERATIONS = 400,
	TEAM = 500,
	BOOKING_MANAGER = 550,
	GUEST = 600,
}

export enum TIMESLOT_STATUS_ENUM {
	NOT_REQUIRED = 'NOT_REQUIRED',
	OFLOAD_MUST_BOOK = 'OFLOAD_MUST_BOOK',
	BOOKED = 'BOOKED'
}

export enum TIMESLOT_LABELS_ENUM {
	NOT_REQUIRED = 'No time slot required. Arrive any time within opening hours.',
	OFLOAD_MUST_BOOK = 'Ofload to book time slot directly with receiver.',
	BOOKED = 'Time slot is booked and is mandatory.'
}

export const timeSlotStatuses = [
	{
		value: (TIMESLOT_STATUS_ENUM.NOT_REQUIRED || TIMESLOT_OPTIONS.NOT_REQUIRED),
		label: 'No time slot required. Arrive any time within opening hours.',
		labelShort: 'No time slot required'
	}, {
		value: (TIMESLOT_STATUS_ENUM.OFLOAD_MUST_BOOK || TIMESLOT_OPTIONS.OFLOAD_MUST_BOOK),
		label: 'Ofload to book time slot directly with receiver.',
		labelShort: 'Carrier must book a time slot'
	}, {
		value: (TIMESLOT_STATUS_ENUM.BOOKED || TIMESLOT_OPTIONS.BOOKED),
		label: 'Time slot is booked and is mandatory.',
		labelShort: 'Time slot is booked & mandatory'
	}
];

export enum APP_SOURCE {
	EOS = 'EOS',
	EOS_BULK_UPLOAD = 'EOS_BULK_UPLOAD',
	EOS_REORDER = 'EOS_REORDER',
	INTEGRATION_API_V2 = 'INTEGRATION_API_V2',
	INTEGRATION_API_NOUMI = 'INTEGRATION_API_NOUMI'
}

export const getAppSourceLabel = (appSource: APP_SOURCE): string => {
	switch (appSource) {
	case APP_SOURCE.EOS:
		return 'Platform - booking form';
	case APP_SOURCE.EOS_REORDER:
		return 'Platform - reorder';
	case APP_SOURCE.EOS_BULK_UPLOAD:
		return 'Platform - bulk upload';
	case APP_SOURCE.INTEGRATION_API_V2:
		return 'Integration - API';
	case APP_SOURCE.INTEGRATION_API_NOUMI:
		return 'Integration - API (Legacy)';
	default:
		return appSource
	}
}

export enum TIMESLOT_STATUS {
	REQUIRED = 'REQUIRED',
	REQUESTED = 'REQUESTED',
	CONFIRMED = 'CONFIRMED',
	REJECTED = 'REJECTED',
	NOT_REQUIRED = 'NOT_REQUIRED'
}

export enum TIMESLOT_STATUS_OPTIONS {
	REQUIRED = 'Required',
	REQUESTED = 'Requested',
	CONFIRMED = 'Confirmed',
	REJECTED = 'Rejected',
	NOT_REQUIRED = 'No time slot'
}

export enum HEXADECIMAL_CHAR_CODE {
	NULL = '\x00'
}

export enum PARTY_ACCOUNTABLE {
	SHIPPER = 'Shipper',
	CARRIER = 'Carrier',
	EXTERNAL = 'External',
	BOTH = 'Shipper & Carrier',
}

export enum PRICING_METHOD {
	CPK = 'CPK',
	LOOSE = 'Weight',
	PALLETS = 'Pallets',
	FULL_LOAD = 'FullLoad',
	VOLUME = 'Volume'
}

export enum ALLOCATION_PRICING_METHOD {
	PALLETS = 800001,
	FULL_LOAD = 800002,
	CPK = 800003,
	LOOSE = 2,
	CUSTOM_ITEM = 800007,
}

export const AU_BOUND = {
	east: 153.569469029,
	west: 113.338953078,
	north: -10.6681857235,
	south: -43.6345972634,
}

export const ManifestFilterableStatus = [
	{ label: 'Not Started', value: 'Not Started' },
	{ label: 'On the Road', value: 'On the Road' },
	{ label: 'POD Required', value: 'POD Required' },
	{ label: 'POD Awaiting Verification', value: 'POD Awaiting Verification' },
	{ label: 'POD Rejected', value: 'POD Rejected' },
	{ label: 'Awaiting Invoice', value: 'Awaiting Invoice' },
	{ label: 'Paid', value: 'Paid' },
];

export enum FILE_STATUS {
	NEW = 'NEW',
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETE = 'COMPLETE',
	INCOMPLETE = 'INCOMPLETE',
	FAILED = 'FAILED',
}

export enum FILTER_OPERATORS {
	AND = 'and',
	OR = 'or',
	IS = 'is',
	IS_NOT = 'is not',
	LESS_THAN = 'less than',
	AT_MOST = 'at most',
	GREATER_THAN = 'greater than',
	AT_LEAST = 'at least',
	CONTAINS = 'contains',
	HAS = 'has',
	BETWEEN = 'between'
}

export const TSOperators = [
	{ label: FILTER_OPERATORS.AND, value: FILTER_OPERATORS.AND },
	{ label: FILTER_OPERATORS.OR, value: FILTER_OPERATORS.OR },
	{ label: FILTER_OPERATORS.IS, value: '=' },
	{ label: FILTER_OPERATORS.IS_NOT, value: '!=' },
	{ label: FILTER_OPERATORS.LESS_THAN, value: '<' },
	{ label: FILTER_OPERATORS.AT_MOST, value: '<=' },
	{ label: FILTER_OPERATORS.GREATER_THAN, value: '>' },
	{ label: FILTER_OPERATORS.AT_LEAST, value: '>=' },
	{ label: FILTER_OPERATORS.CONTAINS, value: 'contains' },
	{ label: FILTER_OPERATORS.HAS, value: 'has' },
	{ label: FILTER_OPERATORS.BETWEEN, value: 'between' }
];

export enum MARKETPLACE_ACTION_TYPE {
	PLACE_BID = 'PLACE_BID',
	TAKE_NOW = 'TAKE_NOW',
	EDIT_BID = 'EDIT_BID',
	WITHDRAW_BID = 'WITHDRAW_BID',
}

export enum CARRIER_FOOTER_ACTION {
	SEARCH_LOAD = 'SEARCH_LOAD',
	UPLOAD_POD = 'UPLOAD_POD',
	UPDATE_ETA = 'UPDATE_ETA',
}

export enum EMPTY_STATE_TYPES {
	FIRST_USE = 'FIRST_USE',
	USER_CLEARED = 'USER_CLEARED',
}

export enum EMPTY_STATE_IMAGE {
	TUMBLEWEED = 'TUMBLEWEED',
	CLIPBOARD = 'CLIPBOARD',
	TREES = 'TREES'
}

export enum BADGE_SIZE {
	LARGE = 'LARGE',
	EXTRA_LARGE = 'EXTRA_LARGE',
}

/* Analytics Reports ENUMS */

export enum SEND_METHOD {
	GENERATE_NOW = 'Generate Now',
	SCHEDULE = 'Schedule'
}

export enum ANALYTIC_REPORT_TYPE {
	DETAILED_SHIPMENT_SHIPPER_REPORT_INCL_DIFOT = 'DETAILED_SHIPMENT_SHIPPER_REPORT_INCL_DIFOT',
	SHIPMENT_SHIPPER_INVOICE = 'SHIPMENT_SHIPPER_INVOICE'
}

export enum ANALYTIC_REPORT_SCOPE {
	PICK_UP_DATE = 'PICKUP_DATE',
	DROP_OFF_DATE = 'DROP_OFF_DATE',
	ORDER_NUMBER = 'ORDER_NUMBER',
	INVOICE_SENT_AT = 'INVOICE_SENT_AT',
	INVOICE_REFERENCE = 'INVOICE_REFERENCE'
}

export enum ANALYTIC_REPORT_ENTITY_TYPE {
	CARRIER = 'CARRIER',
	SHIPPER = 'SHIPPER',
	ADMIN = 'ADMIN'
}

export enum FILTER_FIELD_TYPE {
	BOOL = 'boolean',
	DATE = 'date',
	DATE_ISO = 'date_iso',
	DATE_EPOCH = 'date_epoch',
	ADDRESS = 'address',
	SHIPPER = 'shipper',
	CARRIER = 'carrier',
	SELECT = 'select',
	SELECT_GROUP = 'select-group',
	MULTI_SELECT = 'multi-select',
	STRING = 'string',
	NUMBER = 'number',
	PERSON = 'person'
}

export enum NOTE_CATEGORY {
	COMPLAINT = 'COMPLAINT',
	DEMURRAGE = 'DEMURRAGE',
	TIME_SLOT = 'TIME_SLOT',
	DROPPED_LOAD = 'DROPPED_LOAD',
	ETA = 'ETA',
	FREIGHT_ISSUES = 'FREIGHT_ISSUES',
	POD_ISSUE = 'POD_ISSUE',
	COR_SAFETY_INCIDENT = 'COR_SAFETY_INCIDENT',
	OTHER = 'OTHER',
	FUTILE = 'FUTILE',
	FINANCE = 'FINANCE',
	DRIVER_NOTES = 'DRIVER_NOTES',
	NON_STANDARD_COST = 'NON_STANDARD_COST',
}

export enum SEVERITY_LABEL {
	INSIGNIFICANT = 'INSIGNIFICANT',
	MINOR = 'MINOR',
	SUBSTANTIAL = 'SUBSTANTIAL',
	SEVERE = 'SEVERE'
}

export const getSeverityLabel = (severity: SEVERITY_LABEL): string => {
	switch (severity) {
	case SEVERITY_LABEL.MINOR:
		return 'Minor';
	case SEVERITY_LABEL.SUBSTANTIAL:
		return 'Substantial';
	case SEVERITY_LABEL.SEVERE:
		return 'Severe';
	case SEVERITY_LABEL.INSIGNIFICANT:
		return 'Insignificant';
	default:
		return '';
	}
}

export enum INVOICE_ON {
	DELIVERY = 'DELIVERY',
	PICKUP = 'PICKUP',
	POD_VERIFICATION = 'POD_VERIFICATION',
}

export enum ITEM_CHARGE_TYPE {
	CPK = 'CPK',
	PER_ITEM = 'PER_ITEM',
}

export enum STATUS_ISSUES {
	COMPLAINT = 'COMPLAINT',
	TIME_SLOT = 'TIME_SLOT',
	DROPPED_LOAD = 'DROPPED_LOAD',
	FREIGHT_ISSUES = 'FREIGHT_ISSUES',
	COR_SAFETY_INCIDENT = 'COR_SAFETY_INCIDENT',
}

export enum STATUS_ISSUES_LABELS {
	TRUCK_CONDITION = 'Truck Condition and Cleanliness',
	DRIVER_BEHAVIOR = 'Driver Behavior',
	COMPLIANCE_ISSUE = 'Compliance Issue',
	PPE = 'PPE',
	COLLECTION = 'Collection',
	DELIVERY = 'Delivery',
	COLLECTION_MISSED_NO_NOTICE = 'Collection Missed (no notice)',
	COLLECTION_MISSED_WITH_NOTICE = 'Collection Missed (with notice)',
	DELIVERY_MISSED_NO_NOTICE = 'Delivery Missed (no notice)',
	DELIVERY_MISSED_WITH_NOTICE = 'Delivery Missed (with notice)',
	SHIPPER_ADVISED = 'Shipper Advised',
	CARRIER_ADVISED = 'Carrier Advised',
	SHIPPER_CHASING = 'Shipper Chasing',
	OFLOAD_CHASING = 'Ofload Chasing',
	CARRIER_UPDATING = 'Carrier Updating',
	LOST_FREIGHT = 'Lost Freight',
	WRAPPING_ISSUE = 'Wrapping Issue',
	SHORT_DELIVERY = 'Short Delivery',
	PALLET_SPACE_DISCREPANCY = 'Pallet/Space Discrepancy',
	REJECTED_AT_DELIVERY_SITE = 'Rejected at Delivery Site',
	DAMAGED_FREIGHT = 'Damaged Freight',
	INCORRECT_SHIPMENT_INFO = 'Incorrect Shipment Information Provided by Shipper',
	POD_REJECTED_BY_SHIPPER = 'POD Rejected by Shipper',
	CARRIER_ADVISING_NOT_AVAILABLE = 'Carrier Advising Not Available',
	CHASED_AND_ABANDONED = 'Chased and Abandoned',
	IN_DISPUTE = 'In Dispute',
	LOAD_NOT_DELIVERED = 'Load Not Delivered',
	PROPERTY_DAMAGE = 'Property Damage',
	SAFETY_NEAR_MISS = 'Driver Injury/Safety Near Miss',
	DANGEROUS_GOODS = 'Dangerous Goods',
	VEHICLE_ACCIDENT = 'Vehicle Accident',
	SPEED_FATIGUE_RELATED = 'Speed/Fatigue Related',
	VEHICLE_MAINTENANCE = 'Vehicle Maintenance',
	LOAD_RESTRAINT = 'Load Restraint',
	MASS_DIMENSION = 'Mass/Dimension',
	CARRIER_DO_NOT_PAY = 'Do Not Pay',
	CARRIER_NO_INVOICE = 'No Carrier Invoice Provided',
	SHIPPER_PROMISED_TO_PAY = 'Shipper Promised to Pay',
	SHIPPER_PAYMENT_DISPUTE = 'Shipper Payment Dispute',
	CARRIER_INVOICE_PENDING = 'Carrier Invoice Pending/Chasing',
	CARRIER_PAYMENT_DISPUTE = 'Carrier Payment Dispute',
	DRIVER_NOTES = 'Driver Notes',
	NON_STANDARD_COST = 'Non-standard Cost',
	TEMP_QUALITY_REJECTION = 'Temp/Quality Rejection',
	REJECTED_SHIPPER_FAULT = 'Rejected - Shipper Fault',
	OTHER = 'Other',
}

export enum INTEGRATION_NAME {
	WEBHOOK = 'Webhook',
	EDI = 'EDI',
}

export enum PROOF_TYPE {
	POD = 1,
	EXTRA_DOCUMENT = 2
}

export const getPodStatusLabel = (podStatus: POD_STATUS): string => {
	switch (podStatus) {
	case POD_STATUS.POD_REQUIRED:
		return 'Awaiting POD';
	case POD_STATUS.POD_AWAITING_VERIFICATION:
		return 'POD Awaiting Verification';
	case POD_STATUS.POD_REJECTED:
		return 'POD Rejected';
	case POD_STATUS.POD_VERIFIED:
		return 'POD Approved';
	case POD_STATUS.POD_CHASING:
		return 'Ofload Chasing';
	case POD_STATUS.POD_IN_DISPUTE:
		return 'In Dispute';
	case POD_STATUS.POD_CHASED_AND_ABANDONED:
		return 'Chased And Abandoned';
	case POD_STATUS.POD_NOT_AVAILABLE:
		return 'Carrier Advising Not Available';
	case POD_STATUS.LOAD_NOT_DELIVERED:
		return 'Load Not Delivered';
	case POD_STATUS.POD_SHIPPER_CHASING:
		return 'Shipper Chasing';
	case POD_STATUS.POD_REJECTED_BY_SHIPPER:
		return 'Rejected By Shipper';
	case POD_STATUS.POD_AUTO_APPROVED:
		return 'POD Auto Approved';
	case POD_STATUS.POD_AUTO_REJECTED:
		return 'POD Auto Rejected';
	case POD_STATUS.POD_VERIFIED_PROCESSING:
		return 'Verified POD & Processing';
	default:
		return ''
	}
};

export const POD_STATUS_OPTIONS = [
	{
		label: getPodStatusLabel(POD_STATUS.POD_IN_DISPUTE),
		stringVal: POD_STATUS.POD_IN_DISPUTE,
		numberVal: POD_STATUS_STRING_TO_NUM(POD_STATUS.POD_IN_DISPUTE),
	}, {
		label: getPodStatusLabel(POD_STATUS.POD_NOT_AVAILABLE),
		stringVal: POD_STATUS.POD_NOT_AVAILABLE,
		numberVal: POD_STATUS_STRING_TO_NUM(POD_STATUS.POD_NOT_AVAILABLE),
	}, {
		label: getPodStatusLabel(POD_STATUS.POD_CHASED_AND_ABANDONED),
		stringVal: POD_STATUS.POD_CHASED_AND_ABANDONED,
		numberVal: POD_STATUS_STRING_TO_NUM(POD_STATUS.POD_CHASED_AND_ABANDONED),
	}, {
		label: getPodStatusLabel(POD_STATUS.LOAD_NOT_DELIVERED),
		stringVal: POD_STATUS.LOAD_NOT_DELIVERED,
		numberVal: POD_STATUS_STRING_TO_NUM(POD_STATUS.LOAD_NOT_DELIVERED),
	}, {
		label: getPodStatusLabel(POD_STATUS.POD_SHIPPER_CHASING),
		stringVal: POD_STATUS.POD_SHIPPER_CHASING,
		numberVal: POD_STATUS_STRING_TO_NUM(POD_STATUS.POD_SHIPPER_CHASING),
	}, {
		label: getPodStatusLabel(POD_STATUS.POD_CHASING),
		stringVal: POD_STATUS.POD_CHASING,
		numberVal: POD_STATUS_STRING_TO_NUM(POD_STATUS.POD_CHASING),
	}, {
		label: getPodStatusLabel(POD_STATUS.POD_REJECTED_BY_SHIPPER),
		stringVal: POD_STATUS.POD_REJECTED_BY_SHIPPER,
		numberVal: POD_STATUS_STRING_TO_NUM(POD_STATUS.POD_REJECTED_BY_SHIPPER),
	}
];

export enum CLAIM_STATUS {
	OPEN = 'OPEN',
	CLOSED = 'CLOSED',
	NONE = 'NONE'
}

export enum BULK_UPLOAD_TYPES {
	CREATE_ISSUE_AND_CLAIM = 'create_issue_and_claim',
	BATCH_PAYMENT = 'batch_payment'
}

export enum TRANSPORT_SHIPMENT_PAGES {
	STOP_DETAILS = 'Stop Details',
	POD = 'Proof of Delivery',
	PRICING_INFO = 'Pricing Info',
	IANDC = 'Issues and Claims',
	NOTES = 'Notes',
	HISTORY = 'History'
}

export enum DYNAMIC_DAYS {
	TODAY = 'Today',
	YESTERDAY = 'Yesterday',
	TOMORROW = 'Tomorrow',
	LAST_7 = 'Last 7 Days',
	NEXT_7 = 'Next 7 Days',
	LAST_30 = 'Last 30 Days'
}

export enum FILTER_MODE {
	AND = 'and',
	OR = 'or'
}

export enum SHIPPER_SHIPMENT_PAGES {
	OVERVIEW = 'Overview',
	STOP_DETAILS = 'Stop Details',
	DOCUMENTS = 'Documents',
	NOTES = 'Notes',
	HISTORY = 'History'
}

export enum BID_STATUS {
	BIDED = 'bided',
	WON = 'won',
	LOST = 'lost',
	WITHDRAWN = 'withdrawn',
}

export enum FLAG_VIEW_MODE {
	TILE = 'TILE',
	TABLE = 'TABLE'
}

export enum SEARCH_MODE {
	ONE = 'one',
	MANY = 'many'
}

/* The `event_type` a price adjustment history entry carries. */
export enum PRICE_ADJUSTMENT_EVENT {
	UPDATED_CARGO = 'Updated Cargo',
	UPDATED_MODIFIERS = 'Updated Modifiers'
}
